import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { ResponsiveSourceDocumentLink } from '@ctw/shared/content/CCDA/responsive-source-document-link';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';

export const observationDrawerAction: UseResourceDrawerOpenDrawerArgs<'Observation'>['action'] = ({
  model,
}) => ({
  label: 'Observation',
  title: model.title,
  content: {
    body: (
      <ContentCard
        variant="focal"
        title="Details"
        content={{
          header: <ResponsiveSourceDocumentLink model={model} />,
        }}
      >
        <DefinitionList
          items={[
            { label: 'Value', value: model.valueWithUnits },
            { label: 'Effective Date', value: model.dateDisplay },
          ]}
        />
      </ContentCard>
    ),
  },
});
